import React, { lazy, useEffect, useState } from 'react'
import { BrowserRouter, Switch } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import LoggedInLayout from '../layout'
import { ForwardMessageProvider } from '../context/ForwarMessage/ForwardMessageContext'
import { AuthProvider } from '../context/Auth/AuthContext'
import { TicketsContextProvider } from '../context/Tickets/TicketsContext'
import { WhatsAppsProvider } from '../context/WhatsApp/WhatsAppsContext'
import Route from './Route'

const Dashboard = lazy(() => import('../pages/Dashboard/'))
const TicketResponsiveContainer = lazy(() => import('../pages/TicketResponsiveContainer'))
const Signup = lazy(() => import('../pages/Signup/'))
const Login = lazy(() => import('../pages/Login/'))
const Connections = lazy(() => import('../pages/Connections/'))
const SettingsCustom = lazy(() => import('../pages/SettingsCustom/'))
const Relatorios = lazy(() => import('../pages/Relatórios'))
const TicketsTimeReport = lazy(() => import('../pages/TicketsTimeReport'))
const Financeiro = lazy(() => import('../pages/Financeiro/'))
const Users = lazy(() => import('../pages/Users'))
const Contacts = lazy(() => import('../pages/Contacts/'))
const Queues = lazy(() => import('../pages/Queues/'))
const QueueFlow = lazy(() => import('../pages/QueueFlow'))
const Tags = lazy(() => import('../pages/Tags/'))
const MessagesAPI = lazy(() => import('../pages/MessagesAPI/'))
const Helps = lazy(() => import('../pages/Helps/'))
const ContactLists = lazy(() => import('../pages/ContactLists/'))
const ContactListItems = lazy(() => import('../pages/ContactListItems/'))
// import Companies from "../pages/Companies/";
const QuickMessages = lazy(() => import('../pages/QuickMessages/'))
const Kanban = lazy(() => import('../pages/Kanban'))
const CustomKanban = lazy(() => import('../pages/CustomKanban'))
const Crm = lazy(() => import('../pages/Crm'))
const CrmSettings = lazy(() => import('../pages/CrmSettings'))
const CrmConversions = lazy(() => import('../pages/CrmConversions'))
const CrmReports = lazy(() => import('../pages/CrmReports'))
//import kanbanSchedules from "../pages/kanbanSchedules/";
const Schedules = lazy(() => import('../pages/Schedules'))
const Appointments = lazy(() => import('../pages/Appointments'))
const AppointmentReports = lazy(() => import('../pages/AppointmentReports'))
const AppointmentSettings = lazy(() => import('../pages/AppointmentSettings'))
const Campaigns = lazy(() => import('../pages/Campaigns'))
const CampaignsConfig = lazy(() => import('../pages/CampaignsConfig'))
const CampaignReport = lazy(() => import('../pages/CampaignReport'))
const Annoucements = lazy(() => import('../pages/Annoucements'))
const Chat = lazy(() => import('../pages/Chat'))
const ToDoList = lazy(() => import('../pages/ToDoList/'))
const Subscription = lazy(() => import('../pages/Subscription/'))
const Files = lazy(() => import('../pages/Files/'))
const Prompts = lazy(() => import('../pages/Prompts'))
const QueueIntegration = lazy(() => import('../pages/QueueIntegration'))
const Backups = lazy(() => import('../pages/Backups'))
const Roles = lazy(() => import('../pages/Roles'))
const GroupParticipants = lazy(() => import('../pages/GroupParticipants'))
const ForgetPassword = lazy(() => import('../pages/ForgetPassWord/')) // Reset PassWd

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false)

  useEffect(() => {
    const cshow = localStorage.getItem('cshow')
    if (cshow !== undefined) {
      setShowCampaigns(true)
    }
  }, [])

  return (
    <BrowserRouter>
      <AuthProvider>
        <ForwardMessageProvider>
          <TicketsContextProvider>
            <Switch>
              <Route exact path='/login' component={Login} />
              <Route exact path='/signup' component={Signup} />
              <Route exact path='/forgetpsw' component={ForgetPassword} />
              {/* <Route exact path="/create-company" component={Companies} /> */}
              <WhatsAppsProvider>
                <LoggedInLayout>
                  <Route exact path='/' component={Dashboard} isPrivate permission='ver_dashboard' />
                  <Route exact path='/tickets/:ticketId?' component={TicketResponsiveContainer} isPrivate permission='ver_atendimentos' />
                  <Route exact path='/connections' component={Connections} isPrivate permission='ver_conexoes' />
                  <Route exact path='/group-participants' component={GroupParticipants} isPrivate permission='gerencia_grupos' />
                  <Route exact path='/quick-messages' component={QuickMessages} isPrivate permission='ver_respostas_rapidas' />
                  <Route exact path='/todolist' component={ToDoList} isPrivate permission='ver_tarefas' />
                  <Route exact path='/schedules' component={Schedules} isPrivate permission='ver_agendamentos' />
                  <Route exact path='/agenda' component={Appointments} isPrivate permission='ver_agenda|ver_agenda_propria' />
                  <Route exact path='/agenda/relatorios' component={AppointmentReports} isPrivate permission='gerenciar_agenda' />
                  <Route exact path='/agenda/configuracoes' component={AppointmentSettings} isPrivate permission='gerenciar_agenda' />
                  <Route exact path='/tags' component={Tags} isPrivate permission='ver_tags' />
                  <Route exact path='/contacts' component={Contacts} isPrivate permission='ver_contatos' />
                  <Route exact path='/helps' component={Helps} isPrivate permission='ver_ajuda' />
                  <Route exact path='/users' component={Users} isPrivate permission='ver_usuarios' />
                  <Route exact path='/roles' component={Roles} isPrivate permission='manage_roles' />
                  <Route exact path='/files' component={Files} isPrivate permission='ver_lista_arquivos' />
                  <Route exact path='/prompts' component={Prompts} isPrivate permission='ver_openai' />
                  <Route exact path='/backups' component={Backups} isPrivate />
                  <Route exact path='/queue-integration' component={QueueIntegration} isPrivate permission='ver_integracoes' />
                  {/*<Route exact path="/kanban-schedules" component={kanbanSchedules} isPrivate />*/}
                  <Route exact path='/messages-api' component={MessagesAPI} isPrivate permission='ver_api' />
                  <Route exact path='/settings' component={SettingsCustom} isPrivate permission='ver_configuracoes' />
                  <Route exact path='/kanban' component={Kanban} isPrivate permission='ver_kanban' />
                  <Route exact path='/custom-kanban' component={CustomKanban} isPrivate permission='ver_kanban_personalizado' />
                  <Route exact path='/crm' component={Crm} isPrivate permission='ver_crm' />
                  <Route exact path='/crm/settings' component={CrmSettings} isPrivate permission='gerenciar_crm_configuracoes' />
                  <Route exact path='/crm/conversions' component={CrmConversions} isPrivate permission='ver_dashboard_crm' />
                  <Route exact path='/crm/reports' component={CrmReports} isPrivate permission='ver_crm' />
                  <Route exact path='/relatorios' component={Relatorios} isPrivate permission='ver_relatorios' />
                  <Route exact path='/relatorios/tempos-atendimento' component={TicketsTimeReport} isPrivate permission='ver_relatorios' />
                  <Route exact path='/financeiro' component={Financeiro} isPrivate permission='ver_financeiro' />
                  <Route exact path='/queues' component={Queues} isPrivate permission='ver_filas_chatbot' />
                  <Route exact path='/queues/flow' component={QueueFlow} isPrivate permission='ver_filas_chatbot' />
                  <Route exact path='/announcements' component={Annoucements} isPrivate permission='super' />
                  <Route exact path='/subscription' component={Subscription} isPrivate />
                  <Route exact path='/chats/:id?' component={Chat} isPrivate permission='ver_chat_interno' />
                  {showCampaigns && (
                    <>
                      <Route exact path='/contact-lists' component={ContactLists} isPrivate permission='ver_listas_contatos' />
                      <Route exact path='/contact-lists/:contactListId/contacts' component={ContactListItems} isPrivate permission='ver_listas_contatos' />
                      <Route exact path='/campaigns' component={Campaigns} isPrivate permission='ver_listagem' />
                      <Route exact path='/campaign/:campaignId/report' component={CampaignReport} isPrivate permission='ver_listagem' />
                      <Route exact path='/campaigns-config' component={CampaignsConfig} isPrivate permission='ver_configuracoes_campanhas' />
                    </>
                  )}
                </LoggedInLayout>
              </WhatsAppsProvider>
            </Switch>
            <ToastContainer autoClose={3000} />
          </TicketsContextProvider>
        </ForwardMessageProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default Routes
